<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Row, Col, Radio, Text, ButtonGroup } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id);

	let alarmMode = settings?.['flood:0']?.alarm_mode;
	let waitForResponse = false;
	const alarmModeOptions = [
		{
			value: 'intense',
			info: $format('info_alarm_mode_intense', {
				default:
					'Flood is reported. The sound alarm is on and frequent. It can be muted with a button press.',
			}),
		},
		{
			value: 'normal',
			info: $format('info_alarm_mode_normal', {
				default:
					'Flood is reported. The sound alarm is on and can be muted with a button press.',
			}),
		},
		{
			value: 'economic',
			info: $format('info_alarm_mode_economic', {
				default: 'Flood is reported. There is no sound alarm.',
			}),
		},
	];

	const save = async () => {
		waitForResponse = true;
		const res = await gen2Request(
			device,
			'Flood.SetConfig',
			{
				id: device.channel,
				config: {
					alarm_mode: alarmMode !== 'economic' ? alarmMode : 'disabled',
				},
			},
			true,
		);
		onSettingsResponse(res, device);
		waitForResponse = false;
		settings['flood:0'].alarm_mode = alarmMode;
		devices_settings.update_devices_settings(id, settings);
	};
	/**
	 * Intense: Flood is reported to the cloud; the sound alarm is intense and can be muted with the button.
	 * Economic: Flood is reported to the cloud, but the sound alarm stays off.
	 * Normal: Flood is reported to the cloud; the sound alarm is on and can be muted with the button.
	 * rain: Rain mode enabled; the sound alarm stays off.
	 */
	$: if (alarmMode === 'disabled') {
		//this is because they changed the API!!!!
		alarmMode = 'economic';
	}
</script>

<Text styleType="body" class="mb-s"
	>{$format('operation_mode_title', {
		default: 'Configure device operation modes.',
	})}</Text
>
<ButtonGroup
	id="buttongroup-x4zaopb"
	class="mb-l"
	aria-label={$format('flood_alarm_mode', { default: 'Flood alarm mode' })}
>
	<Button class={alarmMode === 'rain' && 'active'} size="m" on:click={() => (alarmMode = 'rain')}>
		{$format('rain_mode', { default: 'Rain mode' })}
	</Button>
	<Button class={alarmMode !== 'rain' && 'active'} size="m" on:click={() => (alarmMode = 'intense')}>
		{$format('flood_mode', { default: 'Flood mode' })}
	</Button>
</ButtonGroup>
<Text styleType="body" class="mb-s"
	>{$format('flood_alarm_mode', {
		default: 'Flood alarm mode',
	})}</Text
>

<Row class="mb-s">
	<Col sm="10" md="11" lg="11">
		{#each alarmModeOptions as mode}
			<Radio
				size="m"
				value={mode.value}
				selected={alarmMode}
				info={mode.info}
				disabled={alarmMode === 'rain'}
				on:click={() => (alarmMode = mode.value)}
				id="radio-agurv94"
				>{capFirstChar(
					$format('option_' + mode.value, {
						default: mode.value,
					}),
				)}</Radio
			>
		{/each}
	</Col>
</Row>
<Button loading={waitForResponse} size="m" width="full" on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
